import { useEffect, useState } from "react";
import { cn } from "../utils";
import { Button } from "./Button";

export interface BackToTopProps {
  threshold?: number;
  position?: "right" | "left";
  offset?: string;
  label?: string;
  className?: string;
}

export function BackToTop({
  threshold = 240,
  position = "left",
  offset = "2rem",
  label = "Back to top",
  className,
}: BackToTopProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > threshold);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const posStyle: React.CSSProperties = { bottom: offset };
  if (position === "right") {
    posStyle.right = offset;
  } else {
    posStyle.left = offset;
  }

  return (
    <div
      className={cn(
        "fixed z-40 transition-all duration-200",
        !visible && "opacity-0 pointer-events-none",
        className
      )}
      style={posStyle}
    >
      <Button
        size="sm"
        variant="primary"
        onClick={handleClick}
        ripple
        className="rounded-full shadow-lg px-4"
      >
        ↑ {label}
      </Button>
    </div>
  );
}
